import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfigurationService } from '../configuration/app-configuration.service';

import { EditionResource } from '../../models/api/edition-resource.model';
import { Edition } from '../../models/api/edition.model';

@Injectable({
    providedIn: 'root'
})
export class EditionResourceService {

    private apiURL    : string;

    editionActive: Edition;
    editionActiveData  = new Subject<Edition>();
    editionActiveData$ = this.editionActiveData.asObservable();

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) { 
        this.apiURL     = this.appConfigurationService.baseApi + '/edition';
    }

    public findResource(resources: EditionResource[], resourceName: string) {

        var resource = resources.find(r => r.resourceId === resourceName);
        return resource ? resource.value : null;

    }

    getEditionById(editionId: number): any {

        const url = this.apiURL + '/' + editionId;
        return this.http.get<Edition>(url).pipe(
            map((data) => {
                this.editionActive = data;
                this.editionActiveData.next(data);
            })
        );

    }

}
